import { object, string } from 'yup';

const schema = object({
  username: string().required('User is required'),
}).camelCase();

export default schema;
